import Ajax from "Utils/ajax";
export const getAllStaffByHRorManager = (data) => Ajax.post('hr/getAllStaffByHRorManager',data);
export const getStaffShiftHistory = (data) => Ajax.post('hr/getStaffShiftHistory',data);
export const getAllShift = (data) => Ajax.post('hr/getAllShift',data);
export const changeStaffShift = (data) => Ajax.post('hr/changeStaffShift',data);
export const deleteShiftChangeRequest = (data) => Ajax.post('hr/deleteShiftChangeRequest',data);